import { Injectable } from '@angular/core';

import { UrlVariable } from '@blaze-shared/projects-domain';
import { BlazeContextService } from '@blaze-shared/shared-ui';
import { NamespaceId } from '@blaze-shared/workflow-domain';

@Injectable()
export class FormulaContextService extends BlazeContextService<FormulaContext | undefined | null> {}

export interface FormulaContext {
  ns: NamespaceId | undefined;
  urlVariables: UrlVariable[];
}
